import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/voucher/segment",

        async list() {
            const url = this.url('/list');

            return await Vue.http.get(url);
        },        
    },
    base
);
